import UniversalCardSelector from './universalCard-selector.vue';

export default {
  install(application) {
    application.component('yx-universalCard-selector', UniversalCardSelector);
  },
};
